import React from "react";
import EntityList from "../../EntityList/EntityList";
import moment from "moment";
import { defineMessages, injectIntl } from "react-intl";

const messages = defineMessages({
  monday: {
    id: "app.periodConditions.monday",
    description: "Monday",
    defaultMessage: "Monday",
  },
  tuesday: {
    id: "app.periodConditions.tuesday",
    description: "Tuesday",
    defaultMessage: "Tuesday",
  },
  wednesday: {
    id: "app.periodConditions.wednesday",
    description: "Wednesday",
    defaultMessage: "Wednesday",
  },
  thursday: {
    id: "app.periodConditions.thursday",
    description: "Thursday",
    defaultMessage: "Thursday",
  },
  friday: {
    id: "app.periodConditions.friday",
    description: "Friday",
    defaultMessage: "Friday",
  },
  saturday: {
    id: "app.periodConditions.saturday",
    description: "Saturday",
    defaultMessage: "Saturday",
  },
  sunday: {
    id: "app.periodConditions.sunday",
    description: "Sunday",
    defaultMessage: "Sunday",
  },
  create: {
    id: "app.periodConditions.addBookingDates",
    description: "Add booking dates",
    defaultMessage: "Add booking dates",
  },
});

function customEntityToListValuesMapper({ entities, currentLocale, intl }) {
  return entities.map(entity => {
    entity.startDate = entity.restrictions.OPEN_BOOKING[0].startDate;
    entity.endDate = entity.restrictions.OPEN_BOOKING[0].endDate;
    if (Array.isArray(entity.restrictions.OPEN_BOOKING[0].weekDays)) {
      const weekDays = entity.restrictions.OPEN_BOOKING[0].weekDays.map(weekday =>
        intl.formatMessage(messages[weekday.toLowerCase()])
      );

      entity.weekDays = weekDays.join();
    }
    entity.timeZone = entity.restrictions.OPEN_BOOKING[0].timeZone;

    entity.hourRange = entity.restrictions.OPEN_BOOKING[0].startHour
      ? `${moment(entity.restrictions.OPEN_BOOKING[0].startHour).format("HH:mm")} - ${moment(
          entity.restrictions.OPEN_BOOKING[0].endHour
        ).format("HH:mm")}`
      : undefined;
    return entity;
  });
}
class PromotionsBookingWindowList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  handleToggle({ event, field, entity, idx }) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onToggleListItem({
      id: entity.id,
      entity,
      idx,
      field,
    });
  }

  handleDelete({ event, entity, idx }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return this.props.onDeleteListItem({
      id: entity.id,
      entity,
      idx,
    });
  }

  handleSort({ event, field, entity, newIndex, oldIndex, swappedEntity }) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return this.props.onSortListItem({
      id: entity.id,
      entity,
      field,
      newIndex,
      swappedEntity,
      oldIndex,
    });
  }

  render() {
    const { config } = this.props;
    const { name, validation, fields, renderers, sorting, locale } = config;
    const {
      entities,
      loading,
      entityError,
      entityResult,
      handleCreate,
      handleEdit,
      nested,
      entityName,
      disabled,
    } = this.props;
    const { handleToggle, handleDelete, handleSort } = this;
    return (
      <EntityList
        loading={loading}
        entityName={entityName}
        entities={entities}
        validation={validation}
        renderers={renderers}
        name={name}
        fields={fields}
        onToggle={handleToggle}
        onDelete={handleDelete}
        onSort={handleSort}
        entityError={entityError}
        entityResult={entityResult}
        handleCreate={handleCreate}
        handleEdit={handleEdit}
        nested={nested}
        sorting={sorting}
        customEntityToListValuesMapper={customEntityToListValuesMapper}
        currentLocale={locale}
        customCreateButtonMessage={messages}
        showEmptyListColumnNames={false}
        disabled={disabled}
      />
    );
  }
}

PromotionsBookingWindowList.propTypes = {};

PromotionsBookingWindowList.defaultProps = {};

export default injectIntl(PromotionsBookingWindowList);
